<template>
  <div class="home-tagline">
    <div class="home-tagline__text fs-200">
      <span
        class="home-tagline__char"
        v-for="char in [...`©FP${globals.shortYear}`]"
      >
        {{ char }}
      </span>
    </div>
    <span class="home-tagline__cta fs-36">
      <AppLink @click="isMailConfirmVisible = true; useTrackEvent('contact_click', { link_location: 'homepage_tagline' })"
        >Shape <br />
        your project.
      </AppLink>
    </span>
  </div>
</template>

<script setup>
const globals = useGlobal();
const isMailConfirmVisible = useMailConfirmModal();
const props = defineProps({});
</script>

<style lang="scss" scoped>
.home-tagline {
  bottom: 0;
  clip-path: inset(0 0 -5% 0);
  color: var(--c-text);
  display: flex;
  left: 0;
  margin: auto;
  overflow: hidden;
  padding-bottom: var(--offset);
  position: absolute;
  right: 0;
  width: var(--width);
  z-index: layer(overlay);
}

.home-tagline__text {
  display: flex;
  height: 1.1cap;
  line-height: 0.9;
  margin-left: -0.03em;
  user-select: none;
}

.home-tagline__cta {
  position: absolute;
  left: calc(var(--offset) + var(--col-5));
  bottom: var(--offset);
  display: flex;

  &:not(.is-animated) {
    &:deep(.link-line) {
      transform: translateY(100%);
    }
  }
}

.home-tagline__char {
  display: inline-flex;
  transform: translateY(120%);
}
</style>
